import { styled } from 'styled-components';
import { MobileDetailsButton } from '../MobileDetailsButton';

export const Button = styled(MobileDetailsButton)`
  position: absolute;
`;

export const Select = styled.select`
  appearance: none;
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
`;

export const Container = styled.div`
  position: relative;
  height: 32px; // hard-coded height to fit with design-system button
`;
